import React, { useEffect, useRef, useState } from 'react';

const pointers = [
  {
    num: 1,
    title: 'Where finding trusted and the right kind of support is simple.',
    icon: 'fas fa-heart'
  },
  {
    num: 2,
    title: 'Where professionals have the tools to help more people.',
    icon: 'fas fa-tools'
  },
  {
    num: 3,
    title: 'Where wellness resources are accessible.',
    icon: 'fas fa-book-open'
  },
  {
    num: 4,
    title: 'Where professionals can scale their practice with dignity.',
    icon: 'fas fa-chart-line'
  },
  {
    num: 5,
    title: 'Where communities grow stronger together.',
    icon: 'fas fa-users'
  }
];

const WhyChoosePsychMitraSection = () => {
  const [visibleItems, setVisibleItems] = useState({});
  const itemRefs = useRef([]);

  useEffect(() => {
    const observers = [];

    itemRefs.current.forEach((el, index) => {
      if (!el) return;
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setVisibleItems((prev) => ({ ...prev, [index]: true }));
            }
          });
        },
        {
          threshold: 0.2,
          rootMargin: '0px 0px -40px 0px'
        }
      );
      observer.observe(el);
      observers.push(observer);
    });

    return () => {
      observers.forEach((obs) => obs.disconnect());
    };
  }, []);

  return (
    <section className="why-choose-psychmitra-section awards-one" style={{ position: 'relative', overflow: 'hidden', padding: '100px 0 90px' }}>
      {/* Background shape / pattern */}
      <div
        className="awards-one__bg"
        style={{
          backgroundImage: 'url(/assets/images/backgrounds/awards-one-bg.png)',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          opacity: 0.85,
          zIndex: 0
        }}
      />

      <div className="container" style={{ position: 'relative', zIndex: 2 }}>
        {/* Section Header */}
        <div className="section-title text-center" style={{ marginBottom: '45px' }}>
          <span className="section-title__tagline" style={{ letterSpacing: '2px', fontWeight: 600 }}>
            WHAT MAKES US DIFFERENT
          </span>
          <h2 className="section-title__title" style={{ fontSize: '38px', marginTop: '8px' }}>
            Why Choose <span style={{ color: '#7c4bb9' }}>PsychMitra?</span>
          </h2>
          <div
            style={{
              display: 'inline-block',
              marginTop: '16px',
              padding: '10px 24px',
              backgroundColor: 'rgba(124, 75, 185, 0.1)',
              border: '1.5px solid rgba(124, 75, 185, 0.3)',
              borderRadius: '30px',
              color: '#5b2d99',
              fontSize: '18px',
              fontWeight: 700,
              letterSpacing: '0.3px',
              boxShadow: '0 4px 15px rgba(124, 75, 185, 0.08)'
            }}
          >
            PsychMitra aims to build a world
          </div>
        </div>

        {/* 2 Column Content Layout */}
        <div className="row align-items-center" style={{ marginTop: '30px' }}>
          {/* Mascot Illustration Column */}
          <div className="col-xl-5 col-lg-5 text-center mb-4 mb-lg-0">
            <div
              className="float-bob-y-2"
              style={{
                position: 'relative',
                display: 'inline-block',
                maxWidth: '100%',
                padding: '15px'
              }}
            >
              {/* Soft purple glow circle behind mascot */}
              <div
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: '320px',
                  height: '320px',
                  borderRadius: '50%',
                  background: 'radial-gradient(circle, rgba(144, 114, 200, 0.35) 0%, rgba(144, 114, 200, 0) 70%)',
                  zIndex: 0,
                  pointerEvents: 'none'
                }}
              />
              <img
                src="/assets/images/mascot/why_pyschmitra2.jpeg"
                alt="PsychMitra Mascot"
                style={{
                  position: 'relative',
                  zIndex: 1,
                  maxHeight: '440px',
                  maxWidth: '100%',
                  width: 'auto',
                  objectFit: 'contain',
                  mixBlendMode: 'multiply',
                  filter: 'drop-shadow(0 15px 30px rgba(93, 37, 156, 0.22))',
                  transition: 'transform 0.4s ease'
                }}
              />
            </div>
          </div>

          {/* Pointers List Column */}
          <div className="col-xl-7 col-lg-7">
            <div className="pointers-container" style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
              {pointers.map((item, index) => {
                const isRevealed = visibleItems[index];

                return (
                  <div
                    key={item.num}
                    ref={(el) => (itemRefs.current[index] = el)}
                    className="pointer-reveal-card"
                    style={{
                      position: 'relative',
                      display: 'flex',
                      alignItems: 'center',
                      background: 'linear-gradient(135deg, #7c4bb9 0%, #582a93 100%)',
                      color: '#ffffff',
                      borderRadius: '20px',
                      padding: '18px 24px',
                      boxShadow: isRevealed
                        ? '0 12px 30px rgba(88, 42, 147, 0.28), 0 2px 6px rgba(0,0,0,0.06)'
                        : '0 4px 12px rgba(0, 0, 0, 0.05)',
                      border: '1px solid rgba(255, 255, 255, 0.22)',
                      opacity: isRevealed ? 1 : 0,
                      transform: isRevealed
                        ? 'translateY(0) scale(1)'
                        : 'translateY(32px) scale(0.96)',
                      transition: `opacity 0.65s cubic-bezier(0.16, 1, 0.3, 1) ${index * 0.1}s, transform 0.65s cubic-bezier(0.16, 1, 0.3, 1) ${index * 0.1}s, box-shadow 0.3s ease`,
                      cursor: 'default'
                    }}
                  >
                    {/* Number Badge */}
                    <div
                      style={{
                        flexShrink: 0,
                        width: '44px',
                        height: '44px',
                        borderRadius: '50%',
                        backgroundColor: '#ffffff',
                        color: '#5b2d99',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 800,
                        fontSize: '19px',
                        marginRight: '20px',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                        border: '2px solid rgba(255, 255, 255, 0.9)'
                      }}
                    >
                      {item.num}
                    </div>

                    {/* Text content with soft typography */}
                    <div style={{ flex: 1 }}>
                      <p
                        style={{
                          margin: 0,
                          color: '#ffffff',
                          fontSize: '17px',
                          lineHeight: '1.5',
                          fontWeight: 600,
                          letterSpacing: '0.2px',
                          textShadow: '0 1px 2px rgba(0,0,0,0.15)'
                        }}
                      >
                        {item.title}
                      </p>
                    </div>

                    {/* Subtle right sparkle icon */}
                    <div
                      style={{
                        flexShrink: 0,
                        marginLeft: '14px',
                        opacity: 0.6,
                        color: '#ffffff',
                        fontSize: '15px'
                      }}
                    >
                      <i className={item.icon}></i>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .pointer-reveal-card {
          transition: all 0.3s ease;
        }
        .pointer-reveal-card:hover {
          transform: translateY(-3px) scale(1.01) !important;
          box-shadow: 0 16px 36px rgba(88, 42, 147, 0.38) !important;
          border-color: rgba(255, 255, 255, 0.45) !important;
        }
        @media (max-width: 767px) {
          .pointer-reveal-card {
            padding: 14px 18px !important;
          }
          .pointer-reveal-card p {
            font-size: 15px !important;
          }
        }
      `}</style>
    </section>
  );
};

export default WhyChoosePsychMitraSection;
